module.exports = __webpack_public_path__ + "img/ESG报告@1x.9e64317c.png";